import { render, staticRenderFns } from "./GiantToggle.vue?vue&type=template&id=1d6b2c48&scoped=true&"
import script from "./GiantToggle.vue?vue&type=script&lang=js&"
export * from "./GiantToggle.vue?vue&type=script&lang=js&"
import style0 from "./GiantToggle.vue?vue&type=style&index=0&id=1d6b2c48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b2c48",
  null
  
)

export default component.exports